// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".replica-controls[data-v-d7f609ac] {\n  padding-left: 2rem;\n  margin-top: 1.5rem;\n}", ""]);
// Exports
module.exports = exports;
